import { type ApiContainerType } from '@Model';
import {
    Card,
    Grid,
    GridColumn,
    GridColumns,
    type IGuiBinder,
    NumberInput,
    TextInput,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-10-21T09:24:28+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

interface IProps {
    binder: IGuiBinder<ApiContainerType>;
}

export const ContainerTypeMainSection = memo(function ContainerTypeMainSection({ binder }: IProps) {
    const i18n = useTranslate('');

    const labelField = useProp(binder, 'label');
    const shorthandField = useProp(binder, 'shorthand');
    const emptyWeightField = useProp<ApiContainerType, number>(binder, 'empty_weight');
    const remarksField = useProp(binder, 'remarks');
    const externalLabelField = useProp(binder, 'external_label');

    return (
        <Card name="ContainerTypeData" border="withoutBorder">
            <Grid>
                <GridColumns spans={[4, 4, 4, 12]}>
                    <TextInput {...labelField} label={i18n('Bezeichnung')} />
                    <TextInput {...shorthandField} label={i18n('Suchcode')} />
                    <NumberInput {...emptyWeightField} label={i18n('Leergewicht (t)')} />
                    <TextInput {...remarksField} label={i18n('Bemerkung')} inputSize={3} />
                </GridColumns>
                <GridColumn span={6}>
                    <TextInput {...externalLabelField} label={i18n('Externe Bezeichnung')} />
                </GridColumn>
            </Grid>
        </Card>
    );
});
